<template>
  <div>
    <div class="ui form clearing segment" id="new-default-package-step">
      <div class="required field">
        <label for="name">Name</label>
        <div class="ui input">
          <input type="text"
                 v-model="p.name"
                 :placeholder="'Name'"
                 name="name">
        </div>
      </div>

      <div class="field">
        <label>Description</label>
        <textarea rows="3"
                  :placeholder="'Description'"
                  v-model="p.description"
                  name="description"></textarea>
      </div>

      <div class="required field">
        <label for="unitPrice">Unit Price</label>
        <div class="ui input">
          <input type="number"
                 v-model="p.unit_price"
                 :placeholder="'Unit Price'"
                 name="unitPrice">
        </div>
      </div>
      <div class="two required fields">
        <div class="required field">
          <label for="quantity">Quantity</label>
          <div class="ui input">
            <input type="number"
                  v-model="p.quantity"
                  :placeholder="'Quantity'"
                  name="quantity">
          </div>
        </div>

        <div class="field">
          <label for="reservation_type">Choose unit measurement</label>
          <select
            class="ui fluid search dropdown"
            id="unit-measurement-search"
            v-model="p.unit_measurement_id"
            name="unitMeasurement"
          >
            <option value="">Choose unit measurement</option>
            <option :value="unitMeasurement.id" v-for="unitMeasurement in unitMeasurements" :key="unitMeasurement.id">
              {{ unitMeasurement.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="two fields">
        <div class="field">
          <label for="start_at">Start At</label>
          <div style="text-align: center" class="ui calendar" :id="'start-at'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'Start At'"
                     readonly=""
                     name="start_at">
            </div>
          </div>
        </div>

        <div class="field">
          <label for="finish_at">Finished At</label>
          <div style="text-align: center" class="ui calendar" :id="'finish-at'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'Finish At'"
                     readonly=""
                     name="finish_at">
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="ui segment field">
        <div class="ui toggle checkbox">
          <input type="checkbox" v-model="package.isGlobal" />
          <label>Create for all clinics</label>
        </div>
      </div> -->
      
      <div class="ui info message" v-if="errors.length">
        <div class="header">
          There were some errors with your submission
        </div>
        <ul class="list" v-for="(error, index) in errors" :key="index">
          <li>{{ error }}</li>
        </ul>
      </div>

      <div class="ui divider">  </div>

      <div class="ui blue right floated button"
           style="background-color: #092442"
           :class="{disabled: isNotValidForm || isPressed}"
           @click="submit()">
        Submit
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    apiURL: { type: String, required: true },
    object: { type: Object, required: true },
    p: { type: Object, required: true },
    forItemCategory: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      isNotValidForm: true,
      isPressed: false,
      errors: []
    }
  },
  watch: {
    p: {
      handler: function () {
        this.errors = []
        if (!this.p.name) {
          this.errors.push('Please, Write the name for this package')
        }

        if (!this.p.unit_price) {
          this.errors.push('Please, Enter the unit price for this package')
        }

        if (!this.p.quantity) {
          this.errors.push('Please, Enter the quantity for this package')
        }

        this.isNotValidForm = this.errors.length > 0
      },
      deep: true
    }
  },
  mounted () {
    if (this.forItemCategory) {
      this.loading = true
      this.$http.get('items/categories').then(response => {
        this.itemCategories = response.data
      })
    }
  },
  methods: {
    getItems () {
      return this.$http.get('items')
    },
    hideModal () {
      $('.modal').modal('hide')
    },
    submit () {
      this.isPressed = true
      this.$http.post(this.apiURL, {
        clinic_id: this.getFromLocalStorage('clinicId'),
        package: this.p
      }).then(response => {
        this.object.packages.push(response.data)
        this.hideModal()
        this.isPressed = false
      }).catch(() => {
        this.isPressed = false
        this.errors.push('Please fill required fields')
      })
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/packages/NewPackage.vue